import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const init = async () => {
      const token = localStorage.getItem('nsu_token');
      if (!token) { setLoading(false); return; }
      try {
        const { data } = await api.get('/auth/me');
        setUser(data.user);
      } catch (_) {
        localStorage.removeItem('nsu_token');
        localStorage.removeItem('nsu_user');
      } finally {
        setLoading(false);
      }
    };
    init();
  }, []);

  const login = async ({ role, mobile, password }) => {
    try {
      const { data } = await api.post('/auth/login', { role, mobile, password });
      localStorage.setItem('nsu_token', data.token);
      localStorage.setItem('nsu_user', JSON.stringify(data.user));
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: e.response?.data?.detail || 'Login failed' };
    }
  };

  const logout = () => {
    localStorage.removeItem('nsu_token');
    localStorage.removeItem('nsu_user');
    setUser(null);
  };

  const registerNokma = async (data) => {
    try {
      await api.post('/auth/register/nokma', data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: e.response?.data?.detail || 'Registration failed' };
    }
  };

  const registerApplicant = async (data) => {
    try {
      const { data: res } = await api.post('/auth/register/applicant', data);
      localStorage.setItem('nsu_token', res.token);
      localStorage.setItem('nsu_user', JSON.stringify(res.user));
      setUser(res.user);
      return { ok: true, user: res.user };
    } catch (e) {
      return { ok: false, error: e.response?.data?.detail || 'Registration failed' };
    }
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get('/auth/me');
      setUser(data.user);
    } catch (_) {}
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, registerNokma, registerApplicant, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
